export var version = "3.11.6";
//# sourceMappingURL=version.js.map